// extracted by mini-css-extract-plugin
module.exports = {"root":"MembersItem-module__root__3UmrU","top-border":"MembersItem-module__top-border__23Mie","remove-btn":"MembersItem-module__remove-btn__1ZTCv"};